import React from 'react';

import { runningInRNWebView } from '@/domain/app/hooks/useProxiedNativeProps';

import { useSession } from '@components/app/Session';
import { isUnder18 } from '@utils/date-utils';
import { isOver18 } from '@utils/user-utils';

type GoogleWalletHighAssuranceController = React.PropsWithChildren<{
    lowAssuranceWarning: React.ReactNode;
    onlyNativeAllowedWarning: React.ReactNode;
}>;

export const BlockAdultsWithLowAssurance = ({
    children,
    lowAssuranceWarning,
    onlyNativeAllowedWarning,
}: GoogleWalletHighAssuranceController) => {
    const session = useSession();

    if (!session.user?.birthDate || isUnder18(session.user.birthDate!)) {
        return children;
    }

    if (!runningInRNWebView) {
        return onlyNativeAllowedWarning;
    }

    if (!session.user || (isOver18(session.user) && !session.highAssurance)) {
        return lowAssuranceWarning;
    }

    return children;
};
